import React from 'react';
import withFlagWrapper from '@bubble-ui/hoc-with-flag-wrapper';
import Shape from '@bubble-ui/primitive-shape';
var FlagBY = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Shape, {
  fill: "#FCFCFC",
  d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "m10.326 23.187-2.717-4.93 2.717-4.852 2.717 4.852-2.717 4.93ZM4.891 23.187l-2.717-4.93 2.717-4.852 2.718 4.852-2.718 4.93ZM10.326 36.595l-2.717-4.93 2.717-4.853 2.717 4.853-2.717 4.93ZM4.891 36.595l-2.717-4.93 2.717-4.853 2.718 4.853-2.718 4.93ZM13.043 4.853l-.769-1.374a25.068 25.068 0 0 0-3.867 2.823l1.919 3.48 2.717-4.93ZM10.326 40.217l-1.939 3.462a25.074 25.074 0 0 0 3.864 2.828l.793-1.437-2.718-4.853Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#6DA544",
  d: "M15.217 31.521v16.49A24.918 24.918 0 0 0 25 50c10.75 0 19.913-6.784 23.445-16.304l-33.228-2.174Z"
}), /*#__PURE__*/React.createElement(Shape, {
  fill: "#A2001D",
  d: "M48.445 33.696A24.944 24.944 0 0 0 50 25C50 11.193 38.807 0 25 0c-3.472 0-6.778.708-9.783 1.987v31.709h33.228Z"
}));
FlagBY.displayName = 'FlagBY';
export default withFlagWrapper(FlagBY);
//# sourceMappingURL=index.js.map